import React from "react";
import Box from "@mui/material/Box";
import { styled, SxProps } from "@mui/material/styles";
import { EmtIcon } from "./EmtIcon";
import { EmtNavLink } from "./EmtNavLink";

export type EmtDrawerLinkProps = {
  children?: React.ReactNode;
  href?: string;
  sx?: SxProps;
  className?: string;
  nonce?: string;
};

const StyledEmtNavLink = styled(EmtNavLink)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& .emt-icons": {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    "& .emt-icons": {
      color: theme.palette.primary.main,
      fontSize: "18px",
    },
    // Override EmtNavLink
    "&:hover, &.active": {
      "& *": {
        fontWeight: "400",
        color: theme.palette.primary.main,
      },
    },
  },
}));

export function EmtDrawerLink(props: EmtDrawerLinkProps) {
  const { children, ...rest } = props;
  return (
    <StyledEmtNavLink {...rest}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <>{children}</>
      </Box>
      <EmtIcon className="emt-right-1" sx={{ color: "black" }} />
    </StyledEmtNavLink>
  );
}
